import Cached from '@mui/icons-material/Cached';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const buybackConfig: IProductConfig = {
  baseUrlProd: routes.bbProd,
  baseUrlSandbox: routes.bbSandbox,
  icon: <Cached />,
  modules: [
    {
      label: 'Buyers Tool',
      path: '/buyerstool',
      roles: ['BuybackAdmin', 'BuybackInternal', 'BuybackBuyer'],
    },
    {
      label: 'Webhooks',
      path: '/webhooks',
      roles: [
        'BuybackAdmin',
        'BuybackExternalDev',
        'BuybackTradeInDeveloper',
        'BuybackBuyerDeveloper',
      ],
    },
    {
      label: 'Seller Management',
      path: '/sellers',
      roles: ['BuybackAdmin'],
    },
    {
      label: 'Buyer Management',
      path: '/buyers',
      roles: ['BuybackAdmin'],
    },
    {
      label: 'Global Tracker',
      path: '/globaltracker',
      roles: ['BuybackGlobalTracker'],
    },
    {
      label: 'Program configuration',
      path: '/configurations',
      roles: ['BuybackAdmin'],
    },
    {
      label: 'Criteria List',
      path: '/criteria-list',
      customRoutes: [routes.stSandbox, routes.stSandbox, routes.stProd],
      roles: ['BuybackAdmin', 'LuxclusifBuyer', 'LuxclusifSeniorBuyer'],
    },
    {
      label: 'Selection Tool',
      path: '/selection-list',
      customRoutes: [routes.stSandbox, routes.stSandbox, routes.stProd],
      roles: ['BuybackAdmin', 'LuxclusifBuyer', 'LuxclusifSeniorBuyer'],
    },
  ],
  product: EProduct.buyback,
  title: 'Buyback',
};

export default buybackConfig;
